import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex-shrink: 0;
  overflow-y: auto;
  width: 100%;
  .modal-footer__variant {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
  }
`

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  .title {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .content__wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
  }

  .vx-checkbox-con {
    margin: 0;
  }

  input {
    min-width: auto !important;
  }
`

export const DatePickerContainer = styled.div`
  display: flex;
  text-align: center;
  /* margin-bottom: 1.25rem; */
  align-items: center;
  justify-content: center;
  position: relative;
  flex: 1;
  @media ${queries.less.xl} {
    width: 88%;
  }

  svg {
    position: absolute;
    left: 7px;
    pointer-events: none;
  }
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #efefef;
  margin: 0;
  flex: 1 0 1px;
`

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  position: sticky;
  top: 0;
  padding-top: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #efefef;
  background: white;
  z-index: 1;
  margin-bottom: 24px;
  .title {
    flex: 1;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .close-button {
    display: flex;
    width: 24px;
    height: 24px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: none;
    &:hover {
      background: var(--blackAlpha-100, rgba(0, 0, 0, 0.06));
    }

    .close-icon {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }
  }
`
